<template>
  <div>
    <v-snackbar v-model="snackbar" color="success" top>
      {{ "alerts_business_updated" | localize }}
    </v-snackbar>
    <VRow
      class="mt-13 mx-6"
      v-if="!editBusiness && $vuetify.breakpoint.smAndDown"
    >
      <v-progress-linear
        height="17"
        style="border-radius: 20px"
        color="#73AFE7"
        value="65"
      ></v-progress-linear>
    </VRow>
    <v-card-title
      :class="$vuetify.breakpoint.smAndDown ? 'mt-2 mx-2' : 'pl-15 mt-3'"
      v-if="!editBusiness && !socials"
      style="word-break: break-word;"
    >
      {{ "add_business_fourth_step_subtitle" | localize }}
    </v-card-title>
    <v-card-title
      :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'pl-15'"
      v-if="!editBusiness && socials"
    >
      Type your location here
    </v-card-title>
    <div style="width: 100%" class="wrapper map" justify="center">
      <div class="searchAddress" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
        <vue-google-autocomplete
          v-if="
            (mapLoaded && loggedUser.role_id === '0') ||
            loggedUser.role_id === '1'
          "
          ref="address"
          id="map"
          v-model="address"
          class="google-autocomplete"
          :class="{ mobile: $vuetify.breakpoint.smAndDown }"
          classname="form-control"
          :placeholder="'add_business_fourth_step_address_search' | localize"
          v-on:inputChange="autocompleteInput"
          v-on:placechanged="getAddressData"
          :style="
            addressError.length
              ? 'color: red; border: 1px solid red !important; border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;'
              : 'color: #72afe7; border: 1px solid #72afe7 !important'
          "
        >
        </vue-google-autocomplete>
        <v-expand-transition>
          <p
            v-if="addressError.length"
            class="pt-2 pl-2 pb-2"
            style="color: red; background: rgba(255, 255, 255, 0.6)"
          >
            {{ addressError.toString() }}
          </p>
        </v-expand-transition>
      </div>
      <GmapMap
        :center="coordinates"
        :zoom="7"
        ref="map"
        map-type-id="roadmap"
        style="width: 100%; height: 400px"
        @click="addMarker"
      >
        <GmapMarker
          :icon="svgMarker"
          :position="marker.position"
          :clickable="true"
          :draggable="true"
        >
        </GmapMarker>
      </GmapMap>
    </div>
    <v-card-actions class="pt-5 pb-5">
      <VRow
        align="center"
        justify="center"
        class="mx-auto"
        v-if="$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <VCol>
          <v-btn
            block
            class="white--text nextLocation"
            color="#72AFE7"
            v-on:click="next()"
            style="
              text-transform: none;
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            "
            v-if="!editBusiness && !socials"
            >{{ "add_business_next" | localize }}</v-btn
          >
          <v-btn
            block
            text
            class="mt-3"
            color="#72AFE7"
            style="text-transform: none"
            v-on:click="$emit('previous')"
            v-if="!editBusiness"
            >{{ "add_business_prev" | localize }}</v-btn
          >
        </VCol>
      </VRow>
      <div
        class="ml-auto"
        v-if="!$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <v-btn block outlined color="#72AFE7" v-on:click="$emit('previous')">{{
          "add_business_prev" | localize
        }}</v-btn>
      </div>
      <div
        class="ml-2 mr-15 d-flex nextLocation"
        v-if="!$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <v-btn class="white--text" color="#72AFE7" v-on:click="next()">{{
          "add_business_next" | localize
        }}</v-btn>
      </div>
      <div
        class="ml-auto mr-10 d-flex"
        v-if="
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            !socials &&
            loggedUser.role_id === '0') ||
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            loggedUser.role_id === '1')
        "
      >
        <v-btn class="white--text" color="#72AFE7" :loading="updateLoading" v-on:click="update()">{{
          "add_business_update" | localize
        }}</v-btn>
      </div>
      <div
        class="ml-2 d-flex"
        v-if="
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            socials &&
            loggedUser.role_id === '0') ||
          (!$vuetify.breakpoint.xs &&
            editBusiness &&
            loggedUser.role_id === '1')
        "
      >
        <v-btn
          class="white--text"
          color="#72AFE7"
          v-on:click="updateSocial()"
          >{{ "add_business_update" | localize }}</v-btn
        >
      </div>
      <div class="ml-2 d-flex" v-if="!editBusiness && socials">
        <v-btn
          class="white--text nextLocation"
          color="#72AFE7"
          v-on:click="next()"
          >Create</v-btn
        >
      </div>
    </v-card-actions>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { gmapApi } from "vue2-google-maps";
import axios from "axios";
import BusinessService from "@/requests/Business/BusinessService";
import SocialService from "@/requests/Socials/SocialService";
import requestFormData from "@/requests/requestFormData";
import { mapGetters } from "vuex";
import Shepherd from "shepherd.js";
import en from "@/locales/en.json";
import es from "@/locales/es.json";

const tour = new Shepherd.Tour({
  defaultStepOptions: {
    scrollTo: true,
    cancelIcon: { enabled: true },
    popperOptions: {
      modifiers: [{ name: "focusAfterRender", enabled: true }],
    },
  },
  useModalOverlay: true,
});

tour.on("cancel", () => {
  if (tour.isActive()) {
    localStorage.tutorialStep = tour.getCurrentStep().id;
  }
});

export default {
  components: {
    VueGoogleAutocomplete,
  },
  props: {
    editBusiness: {
      type: Object,
      require: false,
    },
    updates: {
      require: false,
    },
  },
  data: () => ({
    coordinates: { lat: 20.683293, lng: -103.3551527 },
    marker: { id: 1, position: { lat: 20.683293, lng: -103.3551527 } },
    mapLoaded: false,
    map: null,
    snackbar: false,
    lang: null,
    socials: false,
    address: "",
    addressError: [],
    updateLoading: false,
    svgMarker: {
      path: "M18.27 6c1.01 2.17.78 4.73-.33 6.81c-.94 1.69-2.29 3.12-3.44 4.69c-.5.7-1 1.45-1.37 2.26c-.13.27-.22.55-.32.83c-.1.28-.19.56-.28.84c-.09.26-.2.57-.53.57c-.39 0-.5-.44-.58-.74c-.24-.73-.48-1.43-.85-2.1c-.42-.79-.95-1.52-1.49-2.23L18.27 6M9.12 8.42l-3.3 3.92c.61 1.29 1.52 2.39 2.39 3.49c.21.25.42.51.62.78L13 11.67l-.04.01c-1.46.5-3.08-.24-3.66-1.68c-.08-.17-.14-.37-.18-.57a3.05 3.05 0 0 1 0-1v-.01m-2.54-3.8l-.01.01c-1.62 2.05-1.9 4.9-.93 7.31L9.63 7.2l-.05-.05l-3-2.53m7.64-2.26L11 6.17l.04-.01c1.34-.46 2.84.12 3.52 1.34c.15.28.27.58.31.88c.06.38.08.65.01 1.02v.01l3.2-3.8a6.988 6.988 0 0 0-3.85-3.24l-.01-.01M9.89 6.89l3.91-4.65l-.04-.01C13.18 2.08 12.59 2 12 2c-1.97 0-3.83.85-5.15 2.31l-.02.01l3.06 2.57z",
      fillColor: "#72AFE7",
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 2,
      anchor: { x: 12, y: 25 },
    },
  }),
  destroyed() {
    this.resetSteps();
  },
  mounted() {
    if (process.env.VUE_APP_TYPE == "Social") {
      this.socials = true;
    }
    this.updateStepsText();
  },
  created() {
    if (!this.editBusiness) {
      this.marker.position = {};
      //this.$getLocation({})
      // .then((coord) => {
      //   if (coord) {
      //     this.coordinates = coord;
      //     this.marker.position = coord;
      //     this.getStreetAddressFrom();
      //   }
      // })
      // .catch(() => {
      //this.marker.position = { lat: 20.683293, lng: -103.3551527 };
      //});
    } else {
      this.marker.position = {
        lat: parseFloat(this.editBusiness.geo_lat),
        lng: parseFloat(this.editBusiness.geo_lon),
      };
      this.coordinates = {
        lat: parseFloat(this.editBusiness.geo_lat),
        lng: parseFloat(this.editBusiness.geo_lon),
      };
    }
    this.getStreetAddressFrom();
    if (this.google) {
      this.mapLoaded = true;
    }
  },
  watch: {
    updates: {
      deep: true,
      handler() {
        if (this.socials) {
          this.updateSocial();
        } else {
          this.update();
        }
      },
    },
    address: {
      deep: true,
      handler() {
        if (this.address) {
          this.addressError = [];

          if (this.editBusiness && this.$vuetify.breakpoint.smAndDown) {
            let business = {}
            business.address = this.address
            business.geo_lat = this.marker.position.lat
            business.geo_lon = this.marker.position.lng

            this.$emit('changed_business', business)
          }
        }
      },
    },
    loggedUser: function (newUser) {
      this.loggedUser = newUser;
      this.updateStepsText();
    },
    google: function () {
      this.mapLoaded = true;
    },
  },
  computed: {
    ...mapGetters(["loggedUser"]),
    google: gmapApi,
  },
  methods: {
    updateStepsText() {
      if (this.loggedUser.locale === "en") {
        this.lang = en;
      } else {
        this.lang = es;
      }
    },
    resetSteps() {
      tour.removeStep("map");
      tour.removeStep("nextLocation");
      tour.complete();
    },
    next() {
      if (this.address !== "") {
        let check = tour.isActive();
        this.getStreetAddressFrom();
        this.$emit(
          "addedLocation",
          this.marker.position.lat,
          this.marker.position.lng,
          this.address,
          check
        );
        tour.complete();
      } else {
        this.addressError.length
          ? ""
          : this.addressError.push("Address field is required");
      }
    },
    autocompleteInput() {
      this.addressError = [];
      setTimeout(() => {
        this.address = this.$refs.address.$refs.autocomplete.value;
      }, 100);
    },
    addMarker(e) {
      this.marker = {
        id: 1,
        position: { lat: e.latLng.lat(), lng: e.latLng.lng() },
      };

      this.getStreetAddressFrom();
    },
    getAddressData(e) {
      //this.address = e.addressData;
      this.marker.position = { lat: e.latitude, lng: e.longitude };
      this.coordinates = { lat: e.latitude, lng: e.longitude };

      this.getStreetAddressFrom();
    },

    async getStreetAddressFrom() {
      var { data } = await axios.get(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          this.marker.position.lat +
          "," +
          this.marker.position.lng +
          "&key=" +
          process.env.VUE_APP_MAPSKEY
      );
      this.$refs.address.$refs.autocomplete.value =
        data.results[0].formatted_address;
      this.address = data.results[0].formatted_address;
      console.log(this.address);
    },
    getLast() {
      setTimeout(function () {
        tour.start();
        tour.show("nextLocation");
      }, 500);
    },
    nextTutorial() {
      let that = this;
      tour.addStep({
        id: "map",
        text: that.lang["tour-create-business-enter-address"],
        attachTo: {
          element: ".map",
          on: "top",
        },
        buttons: [
          {
            text: that.lang["tour-previous-step"],
            action() {
              tour.complete();
              that.$emit("toLastStep");
            },
            classes: "shepferd-theme-prev-btn",
          },
          {
            text: that.lang["tour-next-step"],
            action: tour.next,
            classes: "shepferd-theme-next-btn",
          },
        ],
      });
      tour.addStep({
        id: "nextLocation",
        text: that.lang["tour-create-business-next"],
        attachTo: {
          element: ".nextLocation",
          on: "top",
        },
        buttons: [
          {
            text: that.lang["tour-previous-step"],
            action: tour.back,
            classes: "shepferd-theme-prev-btn",
          },
        ],
      });
      tour.start();
      if (tour.isActive()) {
        let tutorialStep = localStorage.tutorialStep;
        if (tutorialStep == "map" || tutorialStep == "nextLocation") {
          tour.hide();
          tour.show(localStorage.tutorialStep);
        }
      }
    },
    update() {
      this.updateLoading = true
      let subcategories = [];
      if (this.editBusiness.categories.length > 1) {
        for (
          let i = 0;
          i < this.editBusiness.categories[1].subcategory.length;
          i++
        ) {
          subcategories.push({
            category_id: parseInt(this.editBusiness.categories[1].id),
            subcategory_id: this.editBusiness.categories[1].subcategory[i].id,
          });
        }
      } else {
        [{ ...this.editBusiness.categories }].forEach((category) =>
          subcategories.push({ category_id: Object.keys(category)[0] })
        );
      }
      let data = {
        //type: parseInt(this.editBusiness.type_id),
        shop_name: this.editBusiness.shop_name,
        shop_description: this.editBusiness.shop_description,
        shop_email: this.editBusiness.shop_email,
        phone_code: this.editBusiness.phone_code,
        phone_number: this.editBusiness.phone_number,
        shop_website: this.editBusiness.shop_website,
        shop_logo: this.editBusiness.shop_logo,
        address: this.address || "",
        geo_lat: this.marker.position.lat,
        geo_lon: this.marker.position.lng,
        neighbourhood: parseInt(this.editBusiness.neighbourhood),
        device_access: parseInt(this.editBusiness.device_access),
        internet: this.editBusiness.internet,
        size: parseInt(this.editBusiness.size),
        canaco_id: this.editBusiness.canaco_id,
        discount_amount_min: parseInt(this.editBusiness.discount_amount_min) || 5,
        discount_amount_max: parseInt(this.editBusiness.discount_amount_max) || 5,
        discount_type: this.editBusiness.discount_type || 'All',
        category: subcategories,
        working_days: this.editBusiness.shop_working_days,
        working_hours: this.editBusiness.working_hours,
        city_id: this.editBusiness.city_id,
        municipality: this.editBusiness.municipality,
      };
      let form = requestFormData.jsonToFormData(data);
      BusinessService.updateBusiness(this.$route.params.bid, form).then(() => {
        this.snackbar = true;
        this.updateLoading = false
        this.$emit("updated");
      });
    },
    updateSocial() {
      let data = {
        type: parseInt(this.editBusiness.type),
        name: this.editBusiness.name,
        description: this.editBusiness.description,
        email: this.editBusiness.email,
        is_public: this.editBusiness.is_public,
        phone_code: this.editBusiness.phone_code,
        phone_number: this.editBusiness.phone_number,
        website: this.editBusiness.website,
        address: this.address || "",
        geo_lat: this.marker.position.lat,
        geo_lon: this.marker.position.lng,
        neighbourhood: parseInt(this.editBusiness.neighbourhood),
        internet: this.editBusiness.internet,
        size: parseInt(this.editBusiness.size),
        working_days: this.editBusiness.working_days,
        working_hours: this.editBusiness.working_hours,
      };
      let form = requestFormData.jsonToFormData(data);
      SocialService.updateSocial(this.$route.params.sid, form).then(() => {
        this.snackbar = true;
        this.$emit("updated");
      });
    },
  },
};
</script>

<style scoped lang="scss">

.searchAddress {
  position: absolute;
  z-index: 4;
  width: 50%;
  height: 40px;
  left: 25%;
  top: 20px;
  &.mobile {
    top: 55px;
    left: 10px;
    margin-right: 50px;
    width: 95%;
  }
}
.google-autocomplete {
  background: white;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  height: 40px;
  color: #72afe7;
  border: 1px solid #72afe7 !important;
  text-transform: none;
  left: 25%;
  top: 20px;
  &.mobile {
    top: 55px;
    left: 10px;
    margin-right: 50px;
    width: 100%;
  }
}
.map {
  position: absolute;
}
.wrapper {
  position: relative;
  width: 100%;
  height: 400px;
}
</style>